import axios from 'axios'
const Get = ({url, data,ContentType}) => {
    return axios.get('http://admin.fanmengit.com/api/' + url, {
        params: data
    })
}

export default Get
